module.exports = __webpack_public_path__ + "static/media/Bus.14559a7c.png";